<template>
    <section>
        <section>
            <h3>Project</h3>
            <p v-if="project" v-text="project.name"></p>
            <loading v-else></loading>
        </section>

        <section v-show="isNew">
            <h3>Submittal Information</h3>
            <submittal-information v-if="submittal" :submittal="submittal"></submittal-information>
            <loading v-else></loading>
        </section>

        <section v-show="isNew">
            <h3>Selected Products</h3>
            <selected v-if="submittal" :temporaryProducts="temporaryProducts"></selected>
            <loading v-else></loading>
        </section>

        <section>
            <h3>Other Submittals</h3>
            <project v-if="project" :project="project"></project>
            <loading v-else></loading>
        </section>
    </section>
</template>

<script>
    import selected from 'vue/submittal-manager/mechanical/sidebar/_selected';
    import submittalInformation from 'vue/submittal-manager/mechanical/sidebar/_submittal-information';
    import project from 'vue/submittal-manager/mechanical/sidebar/_project';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        computed: {
            isNew() {
                return this.$route.name == "new-mechanical-information" ? false : true;
            },

            ...mapGetters('mechanical', [
                'submittal',
                'project',
                'temporaryProducts'
            ])
        },
        components: {
            "selected": selected,
            "submittal-information": submittalInformation,
            "project": project
        }
    }
</script>
